export interface IDLRManagementFormValues {
  userName: string
  userId: number | null
  successUrl: string
  faildUrl: string
  statusText: string
  status: string
}

export interface IDLRList extends Omit<IDLRManagementFormValues, 'statusText'> {
  id: number
}

export const initDLRMangementFormValues: IDLRManagementFormValues = {
  userName: '',
  userId: null,
  successUrl: '',
  faildUrl: '',
  statusText: '',
  status: '0',
}
